import { useState } from 'react'
import FormComponent from '../Form/Form'
import { TextInputComponent, ButtonComponent, LoadingSpinnerComponent } from '../../uicomponents'
import { ClientTypes } from '../../utilities/constants'
import { useDispatch } from 'react-redux'
import { showMessage, deleteMessage } from '../../redux/states/emailSlice'
import { showError, resetError } from '../../redux/states/errorSlice'
import { sendEmailWaitlist } from '../../services/email.service'
import { Formik } from 'formik'
import { StreetFormSchema } from '../../utilities/validationSchema'
import styles from './FormStreetWaitList.module.scss'

const FormStreetWaitList = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState<boolean>(false)

    const clearFields = (fields:any) => {
        fields.name = ''
        fields.email = ''
    }

    return (
        <Formik
            initialValues={{
                name: '',
                email: ''
            }}
            validationSchema={StreetFormSchema}
            onSubmit={async (valores) => {
                setLoading(true)
                try {
                    const result = await sendEmailWaitlist({
                        email: valores.email,
                        name: valores.name
                    })

                    if (result?.code !== 200) {
                        console.log(result)
                        setLoading(false)
                        return
                    }

                    setLoading(false)
                    dispatch(showMessage({ show: true }))
                    clearFields(valores)

                    setTimeout(() => {
                        dispatch(deleteMessage())
                    }, 4000)

                } catch (e) {
                    setLoading(false)
                    dispatch(showError({ show: true }))
                    setTimeout(() => {
                        dispatch(resetError())
                    }, 4000)
                }
            }}
        >
            {({ handleSubmit, values, handleChange, handleBlur, errors }) => (
                <FormComponent
                    onSubmit={handleSubmit}
                >
                    <div className={styles.formWrapper}>
                        <TextInputComponent
                            type={'text'}
                            id={'name'}
                            name={'name'}
                            placeholder='Tu nombre*'
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.name && true}
                        />
                        <TextInputComponent
                            type={'email'}
                            id={'email'}
                            name={'email'}
                            placeholder='Tu mail*'
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onError={errors.email && true}
                        />
                        <ButtonComponent
                            client={ClientTypes.STREET}
                            loading={loading}
                        > 
                            {loading ? <LoadingSpinnerComponent /> : '¡Unirme ahora!'}
                        </ButtonComponent>
                    </div>
                </FormComponent>
            )}
        </Formik>
    )
}

export default FormStreetWaitList
